module.exports = __webpack_public_path__ + "img/Diagnosis - Dark Gray.541a2765.png";